// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header[data-v-669be45c]{padding-left:30px;padding-right:30px}div.v-toolbar__title[data-v-669be45c]{padding-right:20px}#help-button-and-avatar[data-v-669be45c]{display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
